module.exports = __webpack_public_path__ + "img/as-facilities.f6e46cfa.jpg";